/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:dialog
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/09/17 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
 */
export const dialog = {
	namespaced: true,
	state: {
		dialogFlg: false,
		callBack: null,
		message: '',
		buttonList: [],
		focusKey: '',
		kind: '',
		linkFlg: false
	},
	getters: {
		// ダイアログフラグを取得します
		isDialogFlg(state) {
			return state.dialogFlg;
		},
		// コールバックを取得します
		getCallBack(state) {
			return state.callBack;
		},
		// メッセージを取得します
		getMessage(state) {
			return state.message;
		},
		// ボタンリストを取得します
		getButtonList(state) {
			return state.buttonList;
		},
		// フォーカスキーを取得します
		getFocusKey(state) {
			return state.focusKey;
		},
		// ダイアログ種別を取得します
		getKind(state) {
			return state.kind;
		},
		// リンクフラグを取得します
		isLinkFlg(state) {
			return state.linkFlg;
		},
	},
	mutations: {
		// ダイアログフラグを設定します
		setDialogFlg(state, flg) {
			state.dialogFlg = flg;
		},
		// コールバックを設定します
		setCallBack(state, callBack) {
			state.callBack = callBack;
		},
		// メッセージを設定します
		setMessage(state, message) {
			state.message = message;
		},
		// ボタンリストを設定します
		setButtonList(state, buttonList) {
			state.buttonList = buttonList;
		},
		// フォーカスキーを設定します
		setFocusKey(state, focusKey) {
			state.focusKey = focusKey;
		},
		// ダイアログ種別を設定します
		setKind(state, kind) {
			state.kind = kind;
		},
		// リンクフラグを設定します
		setLinkFlg(state, flg) {
			state.linkFlg = flg;
		}
	},
	actions: {
	},
	modules: {
	}
}